module.exports = __webpack_public_path__ + "it.svg?38e71ef690245d3e1b365d2f806f822f";